import { Loader2 } from 'lucide-react';
import { useState } from 'react';
import { toast } from 'sonner';
import { Button } from 'src/components/ui/button'
import { Card, CardContent } from 'src/components/ui/card'
import { getBookPrice } from 'src/lib/books';
import { Post } from 'src/lib/entities'
import { initiateBookPayment } from 'src/redux/api/e-book';

const getImageSrc = (book: string) => {
    return `/${book}.jpg`;
};

const BookOrderPayment = ({book}: {book: Post}) => {

  const [loading, setLoading] = useState(false);

  const handleBookPayment = async () => {
    setLoading(true);

    try {
      const data = await initiateBookPayment(book.toUpperCase());

      if(data.message.toLowerCase() === "success") {

        const paymentData = data?.data.data;
        await initiatePayUPayment(paymentData);

      } else {
        toast.error("Failed To Make Payment!");
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

    const initiatePayUPayment = async (formHtml: string) => {
    setLoading(true);
    try {
      if (formHtml) {
        const div = document.createElement("div");
        div.innerHTML = formHtml;
        const form = div.querySelector("form");
        if (form) {
          document.body.appendChild(div);
          form.submit();
          setLoading(false);
        } else {
          throw new Error("Payment form not found in response");
        }
      } else {
        throw new Error("Invalid payment response format");
      }
    } catch (error) {
      toast.error("Failed to initiate payment!");
      console.error("Payment Initiation Error:", error);
    } finally {
      setLoading(false);
    }
  };


  return (
    <div className="mt-16 flex flex-col items-center gap-10">
  <Card className="p-6 w-full max-w-2xl rounded-2xl shadow-md border border-gray-100">
    <div>
      <h2 className="text-2xl font-bold text-gray-800 mb-3">
        Order Your {book.toUpperCase()} Basic Recruitment Test Guidebook
      </h2>
    </div>
    <p className="text-gray-600 leading-relaxed">
      Before ordering your copy of {book.toUpperCase()} Guidebook, please read
      and understand the instructions and Terms & Conditions for ordering.
    </p>
    <h2 className="text-2xl font-extrabold text-primary mt-6">
      Price {getBookPrice(book)}/- <span className='text-lg font-semibold'>Only</span>
    </h2>
  </Card>

  <Card className="m-2 w-64 rounded-2xl border-0 shadow-md hover:shadow-xl transition-transform duration-300 ease-in-out hover:scale-105">
    <CardContent className="h-[360px] flex flex-col justify-between rounded-2xl bg-gradient-to-tr from-teal-400 via-teal-500 to-cyan-500 p-4">
      <div className="flex justify-center">
        <img
          src={getImageSrc(book.toUpperCase())}
          alt={book}
          className="h-[230px] rounded-xl object-cover shadow-md"
        />
      </div>
      <div className="text-center mt-3 text-xl font-bold text-white tracking-wide">
        {book.toUpperCase()}
      </div>

      <div className="flex justify-center">
        <Button className="px-6 py-2 rounded-xl bg-white text-teal-600 font-semibold shadow hover:bg-gray-100 transition" onClick={handleBookPayment} disabled={loading}>
          { loading ? <Loader2/> : "Proceed To Pay"} 
        </Button>
      </div>
    </CardContent>
  </Card>
</div>
  )
}

export default BookOrderPayment